import React from 'react';

import axios from 'axios';

import { withRouter } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'
import { getToken } from '../../store/auth';

//REDUX
import { connect } from 'react-redux';


//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon} from '../inspinia'
import Pagination from "react-js-pagination";
import CircularProgress from '@material-ui/core/CircularProgress';
import Swal from 'sweetalert2';


class Produtos extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            loading: false, 
            filter: "", 
            page: 0,
            form: this.formInitialState(),
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, content: undefined
            },

            emailUsuario: this.props.auth.user.email,

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },

        }

        this.handleBuscarInput      = this.handleBuscarInput.bind(this); 
        this.handlePageChange       = this.handlePageChange.bind(this);
        this.handleAdicionarProduto = this.handleAdicionarProduto.bind(this);
        this.handleChange           = this.handleChange.bind(this);
        this.handleLimparPesquisa   = this.handleLimparPesquisa.bind(this);
        this.handleMensagemSucesso = this.handleMensagemSucesso.bind(this);
    }

    formInitialState() {
        return {
            id: "",
            nomeProduto: "",
            descricao: "",
            rotulo: ""
        }
    }

    componentDidMount()
    {
        this.loadListaProdutos();
    }

    handleMensagemSucesso(nomeProduto) {
        c.TOASTER_SUCCESS(`Campo ${nomeProduto} cadastrado com sucesso!`);
    }

    handleMensagemEdicao(nomeProduto) {
        c.TOASTER_SUCCESS(`Campo ${nomeProduto} editado com sucesso!`);
    }

    handleLimparPesquisa(edicao) {

        let nomeProduto = this.state.form.nomeProduto;

        this.state.list = [];
        this.state.form.id = "";
        this.state.form.nomeProduto = "";
        this.state.form.descricao = "";

        if (edicao) {
            this.handleMensagemEdicao(nomeProduto);

        } else {
            this.handleMensagemSucesso(nomeProduto);

        }

    }

    handleChange(e) {

        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });

    }

    onNomeProdutoChange(produto) {

        const form = this.state.form;
        console.log(produto.descricao);
        this.setState({ form: { ...form, nomeProduto: produto.nome, id: produto.id_produto, descricao: produto.descricao } });

    }

    onLoadingChange(loading) {

        this.setState({...this.state, loading})

    }

    handleAdicionarProduto() {
        const form = this.state.form;

        console.log("ID: ", form.id);
        if(form.id == undefined){
            c.TOASTER_ERROR(`Favor preencher o ID do Produto!`);  
            return;
        }

        if(form.nomeProduto.length == 0){
            c.TOASTER_ERROR(`Favor preencher o NOME do Produto!`);  
            return;
        }
        
        console.log("DESCRICAO: ", form.descricao);
        if(form.descricao == undefined || form.descricao.length == 0){
            c.TOASTER_ERROR(`Favor preencher a DESCRIÇÃO do Produto!`);  
            return;
        }
        
        this.SaveProduto();        
    }

    SaveProduto() {
        let self = this;
        self.setState({...self.state, loading: true});
        let url = `${c.API_BASE_URL}/produto`
        
        const options = {
            method: 'POST' 
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({      
                id_produto: this.state.form.id,
                nome: this.state.form.nomeProduto,
                descricao: this.state.form.descricao,
                rotulo: this.state.form.rotulo
            })
        };

        callApi(url, options, function(response)
        { 
            self.setState({ ...self.state, page: 0 }, self.handleLimparPesquisa());
            self.loadListaProdutos();  
        });
    }

    handleBuscarInput(e)
    {
        this.setState({ ...this.state, filter: e.target.value });   
    }

    handlePageChange(pageNumber) 
    {

        this.state.page = pageNumber;
        this.loadListaProdutos(pageNumber);
    }

    render()
    {


        return (                     
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Produtos</h3>
                            </Title>

                            <Content>
                                
                                <Row className="m-0 mb-2">
                                    <Column size="12" className="p-0 mx-auto container">

                                        <Row className="form-row">
                                            <div className="form-group col-md-2">   
                                                <input type="number" name="id" value={this.state.form.id} onChange={this.handleChange} className="form-control" placeholder="Id Produto"/>                                                 
                                            </div>
                                            <div className="form-group col-md-3">   
                                                <input type="text" name="nomeProduto" value={this.state.form.nomeProduto} onChange={this.handleChange} className="form-control" placeholder="Nome Produto"/>                                                 
                                            </div>
                                            <div className="form-group col-md-3">   
                                                <input type="text" name="descricao" value={this.state.form.descricao} onChange={this.handleChange} className="form-control" placeholder="Descricao"/>                                                 
                                            </div>
                                            <div className="form-group col-md-3">   
                                                <input type="text" name="rotulo" value={this.state.form.rotulo} onChange={this.handleChange} className="form-control" placeholder="Rotulo"/>                                                 
                                            </div>
                                            <div className="form-group col-md-1">
                                                <Button disabled={this.state.loading} onClick={this.handleAdicionarProduto} className="btn btn-primary">Incluir</Button>                                                   
                                            </div>  
                                            <div className="form-group col-md-1">
                                                {this.state.loading && (                    
                                                    <CircularProgress />                    
                                                )}
                                            </div>  
                                                                            
                                        </Row> 
                                        
                                    </Column>

                                    
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this.props.history} contexto={this}/>                                        
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                     
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.size}
                                        totalItemsCount={this.state.list.totalElements}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>                
            </div>
        );
    }
 
    loadListaProdutos(pageNumber)
    {
        let self = this;
        let page = pageNumber === undefined ? 0 : --pageNumber;
        let size = 10;
        
        const url = `${c.API_BASE_URL}/produto?page=${page}&size=${size}`;
        const options = self.state.optionsGet;
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        {
            self.setState({...self.state, loading: false, list: response});
        });
    }

}

class Table extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            loading: false,    
        }

        this.editarClick   = this.editarClick.bind(this);
        this.excluirClick    = this.excluirClick.bind(this);
    }

    editarClick(id)
    {
        let produto = this.props.data.content;
        let nomeProduto = '';

        nomeProduto = produto.filter((produto) => produto.id_produto === id);

        this.props.contexto.onNomeProdutoChange(nomeProduto[0]);

    }


    excluirClick(id) {
        Swal.fire({
            title: 'Realmente deseja excluir este Produto?',
            text: 'Essa ação é irreversível!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#47A789',
            cancelButtonColor: '#ED5358',
            reverseButtons: true,
            preConfirm: () => {},
            allowOutsideClick: () => !Swal.isLoading(),
            showLoaderOnConfirm: true,
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
                let self = this;
                let url = `${ c.API_BASE_URL }/produto/${id}`
                
                const _token = c.AUTH_HEADER(getToken());
                const options =
                {
                    method: 'DELETE'
                    ,headers: { 'Content-Type': 'application/json', 'Authorization': _token }
                };

                fetch(url, options).then(async(response) => {
                    let json = await response.json();

                    if (response.ok) {
                        c.TOASTER_SUCCESS(json.message);
                        self.props.contexto.loadListaProdutos();
                        self.props.contexto.onLoadingChange(false);
                    } else {
                        c.TOASTER_ERROR(json.message);
                    }
                });              
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              c.TOASTER_ERROR('Exclusão cancelada!');
            }
        });
    }

    LoadExcluir(id)
    {

        let self = this;
        let url = `${ c.API_BASE_URL }/produto/${id}`
        
        const options =
        {
            method: 'DELETE'
            ,headers: { 'Content-Type': 'application/json' }
        };

        fetch(url, options).then(async(response) => {
            self.props.contexto.loadListaProdutos();
            self.props.contexto.onLoadingChange(false);
        });
    }

    render()
    {    
        const data = this.props.data; 
        let html = "";

        if (data.content === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.content.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.content.length   > 0)
        {
            html = data.content.map(row =>
                <tr key={row.id_produto} id={row.id_produto}>
                    <td>{row.id_produto}</td>
                    <td>{row.nome}</td>
                    <td>{row.descricao}</td>
                    <td>{row.rotulo}</td>
                    <td className="text-center">
                        <a onClick={() => this.editarClick(row.id_produto)}><Icon name="fa-pencil" className="mx-1 text-success" /></a>
                        <a onClick={() => this.excluirClick(row.id_produto)}><Icon name="fa-times" className="mx-1 text-muted" /></a>
                    </td>
                </tr>           
            );
        }

        return(
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}>       
                        <th>#</th>
                        <th>Nome Produto</th>
                        <th>Descricao</th>
                        <th>Rotulo</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Produtos));